import { registerPlugin } from '@capacitor/core';
import type { PaywallViewPlugin } from './definitions';

const PaywallView = registerPlugin<PaywallViewPlugin>('PaywallView', {
  web: () => import('./web').then(m => new m.PaywallView()),
});

export * from './definitions';
export { PaywallView };
